import { Twitter, Instagram, Facebook, Youtube } from 'lucide-react';

interface SocialLinksProps {
  social?: {
    twitter?: string;
    instagram?: string;
    facebook?: string;
    youtube?: string;
  };
  className?: string;
}

export default function SocialLinks({ social, className = '' }: SocialLinksProps) {
  if (!social) return null;

  const socialIcons = [
    { key: 'twitter', icon: Twitter, url: social.twitter ? `https://twitter.com/${social.twitter}` : null },
    { key: 'instagram', icon: Instagram, url: social.instagram ? `https://instagram.com/${social.instagram}` : null },
    { key: 'facebook', icon: Facebook, url: social.facebook ? `https://facebook.com/${social.facebook}` : null },
    { key: 'youtube', icon: Youtube, url: social.youtube ? `https://youtube.com/${social.youtube}` : null },
  ];

  const activeIcons = socialIcons.filter(icon => icon.url);

  if (activeIcons.length === 0) return null;

  return (
    <div className={`flex space-x-4 ${className}`}>
      {activeIcons.map(({ key, icon: Icon, url }) => (
        <a
          key={key}
          href={url!}
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-600 hover:text-gray-900"
        >
          <Icon className="h-5 w-5" />
        </a>
      ))}
    </div>
  );
}